import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from 'antd'
import { useForm } from 'antd/es/form/Form'
import moment from 'moment'
import React, { useState, useRef } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getMarketCategories, getMarketList } from '../../api/api'
import SecondHandTable from './ components/secondHandTable/secondHandTable'
import { PlusOutlined } from '@ant-design/icons'
import './index.css'

const { RangePicker } = DatePicker

const SecondHand = () => {
  const [componentSize, setComponentSize] = useState('default')
  const [form] = useForm()
  const contentRef = useRef()
  const [payload, setPayload] = useState({ page: '1', pagesize: '10' })
  const [total, setTotal] = useState(0)
  const [dictionary, setDictionary] = useState([]) //字典
  const [fresh, setFresh] = useState(false)

  const navigate = useNavigate()
  const jumpToNew = () => {
    navigate('/newsecondHand')
  }

  useEffect(() => {
    getMarketList({ params: payload }).then((res) => {
      const info = res.data.data
      if (info.total === 0) {
        message.error('未能找到指定条件内容！')
      }
      contentRef.current.changeData(res.data.data.rows)
      setTotal(res.data.data.total)
    })
  }, [payload, fresh])

  useEffect(() => {
    //获取初始字典初始数据
    getMarketCategories({}).then((res) => {
      setDictionary(res.data.data.rows)
      console.log(res.data.data.rows)
    })
  }, [])
  //级联查找的选择
  // const onChange = (value) => {
  //   console.log(value)
  // }

  const pageChange = (e) => {
    //分页改变时的回调函数
    setPayload({
      ...payload,
      page: e,
    })
  }

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size)
  }
  const handleSubmit = (values) => {
    console.log(values)
    let payload = {
      page: '1',
      pagesize: '10',
      title: values.title,
      category: values.category,
      is_on_sale: [values.is_on_sale],
      is_visible: values.is_visible,
    }
    let start = values?.date[0]
    let end = values?.date[1]

    if (start !== '') {
      payload['period_start'] = moment(start).format('YYYY-MM-DD')
    }
    if (end !== '') {
      payload['period_end'] = moment(end).format('YYYY-MM-DD')
    }
    setPayload(payload)
  }

  //重置选项
  const resetSelectors = () => {
    form.resetFields()
  }

  return (
    <div className="secondHandManage">
      <Form
        initialValues={{
          size: componentSize,
          date: ['', ''],
        }}
        onValuesChange={onFormLayoutChange}
        onFinish={handleSubmit}
        size={componentSize}
        className="secondHandSelectors"
        form={form}
      >
        <Row>
          <Col span={8}>
            <Form.Item
              label="帖子信息"
              name="title"
              className="secondHand"
              labelCol={{ span: 6 }}
            >
              <Input placeholder="请输入内容编号/内容标题" />
            </Form.Item>
          </Col>
          <Col span={7}>
            {' '}
            <Form.Item
              label="分类"
              name="category"
              className="secondHandType"
              labelCol={{ span: 4 }}
            >
              <Cascader
                options={dictionary}
                fieldNames={{
                  value: 'id',
                  label: 'name',
                  // children: 'SubCategories',
                }}
                placeholder="请选择"
              ></Cascader>
              {/* <Select placeholder="请选择" style={{ textAlign: 'left' }}>
                {dictionary?
                dictionary.map((item,index) => (
                  <>
                    <Select.Option value={item.ID} >{item.Name}</Select.Option>
                  </>
                ))
                :
                null
              }
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label="发布时间"
              name="date"
              className="secondHandPostTime"
            >
              <RangePicker />
            </Form.Item>
          </Col>
          <Col span={8}>
            {' '}
            <Form.Item
              label="上架状态"
              name="is_on_sale"
              className="is_on_sale"
              labelCol={{ span: 6 }}
            >
              <Select placeholder="请选择" style={{ textAlign: 'left' }}>
                <Select.Option value="1">已上架</Select.Option>
                <Select.Option value="0">已下架</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}></Col>
          <Col>
            {' '}
            <Form.Item style={{ textAlign: 'right' }}>
              {' '}
              <Button
                onClick={resetSelectors}
                style={{ marginRight: '20px', marginLeft: '60px' }}
              >
                重置
              </Button>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Button icon={<PlusOutlined />} type="primary" onClick={jumpToNew}>
              新建{' '}
            </Button>
          </Col>
        </Row>
      </Form>
      <SecondHandTable ref={contentRef} setFresh={setFresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: 'right' }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  )
}
export default SecondHand
